import { ApolloError, gql, useMutation } from "@apollo/client";
import {
  CrPortInput,
  CrPortMutation,
  CrPortMutationVariables,
} from "../generated/graphql";
import { CouponScopeEnum, CouponStatusEnum } from "../constants/enum";

const CR_COUPON_MUTAION = gql`
  mutation crCoupon($input: CrCouponInput!) {
    crCoupon(input: $input) {
      ok
      err
    }
  }
`;

export interface CrCouponMutation {
  crCoupon: {
    ok: boolean;
    err: string;
  };
}

export interface CrCouponInput {
  name: string;
  scope: CouponScopeEnum;
  status: CouponStatusEnum;
  code: string;
  validFrom?: string;
  validUntil?: string;
  description: string;
  usageLimit: number;
  userUsageLimit: number;
  linkServiceId?: number;
  corporationId?: number;
  discountPrice: number;
}

export interface CrCouponVariables {
  input: CrCouponInput;
}

export const useCrCoupon = (
  onCompleted?: (data: CrCouponMutation) => void,
  onError?: (error: ApolloError) => void
) => {
  return useMutation<CrCouponMutation, CrCouponVariables>(CR_COUPON_MUTAION, {
    onCompleted,
    onError,
  });
};
